import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import Styled from './styles';

export interface SnackbarActionProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the message. */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** SnackbarAction, place action buttons here, progress indicator etc. */
const SnackbarAction = React.forwardRef<HTMLElement, SnackbarActionProps>((props: SnackbarActionProps, ref) => getContext(({ RTL, theme: globalTheme }) => {
  const {
    children,
    theme,
    ...otherProps
  } = props;
  const resolvedTheme = _merge({}, globalTheme.SNACKBAR, theme);

  return (
    <Styled.SnackbarAction
      ref={ref}
      $rtl={RTL}
      $theme={resolvedTheme}
      {...otherProps}
    >
      {children}
    </Styled.SnackbarAction>
  );
}));

SnackbarAction.displayName = 'SnackbarAction';

SnackbarAction.defaultProps = {
  theme: {}
};

export default SnackbarAction;
